<div [style.min-height]="isRouteMode ? 'calc(100dvh - 3.8rem)' : null"
     [class]="isRouteMode ? 'tw-bg-gray-100 tw-flex tw-flex-col' : ''">
  <div [style.flex]="isRouteMode ? '1' : null">
    <ng-container *ngIf="!isRegimenExpired">
      @if (acqRebranding2025) {
        <app-regimen-empty-state *ngIf="regimen" [iconSrc]="iconSrc" [iconClass]="$any(regimen.class)" [isRouteView]="isRouteMode">
          @if (regimen.class !== appConfig.Shared.Regimen.Class.HAIR) {
            @if (isRegimenExpiredForPaidUser) {
              <p class="tw-text-center tw-font-bold tw-text-600 tw-leading-[24px] tw-px-4" i18n="@@AnswerFewQuestionsToRestartSkin">
                Answer a few questions <br/> to restart your skin treatment.
              </p>
            } @else {
              <p class="tw-text-center tw-font-bold tw-text-600 tw-leading-[24px]" i18n="@@skinGetStartedNowBr">
                Get started now <br/> with doctor given kit <br/> for your skin.
              </p>
            }
          } @else {
            @if (isRegimenExpiredForPaidUser) {
              <p class="tw-text-center tw-font-bold tw-text-600 tw-leading-[24px] tw-px-4" i18n="@@AnswerFewQuestionsToRestartHair">
                Answer a few questions <br/> to restart your hair treatment.
              </p>
            } @else {
              <p class="tw-text-center tw-font-bold tw-text-600 tw-leading-[24px]" i18n="@@hairGetStartedNowBr">
                Get started now <br/> with doctor given kit <br/> for your hair.
              </p>
            }
          }
          <p class="tw-text-center tw-text-300 tw-leading-[24px] tw-font-normal tw-mt-2" i18n="@@ItOnlyTakes2Minutes"> It only takes 2 minutes!</p>
        </app-regimen-empty-state>
      } @else {
        <div class="tw-w-full tw-min-h-full tw-font-body tw-bg-yellow-100 tw-pt-15" *ngIf="regimen">
          <img class="tw-mx-auto tw-w-20 tw-h-20" [src]="iconSrc" [class]="regimen.class" alt="faceIcon"/>
          @if (regimen.expired) {
            @if (regimen.class !== appConfig.Shared.Regimen.Class.HAIR) {
              <div class="tw-p-6 tw-text-200" i18n="@@skinTreatmentExpired">
                Your treatment kit has expired. Your skin condition might have changed.
                Please click below to get a new treatment.
              </div>
            } @else {
              <div class="tw-p-6 tw-text-200" i18n="@@hairTreatmentExpired">
                Your treatment kit has expired. Your hair condition might have changed.
                Please click below to get a new treatment kit.
              </div>
            }
          } @else {
            <div class="tw-p-6 tw-text-200 tw-text-center" *ngIf="!regimen.expired && regimen.class !== appConfig.Shared.Regimen.Class.HAIR">
              <p class="tw-text-400 tw-font-body tw-font-bold" i18n="@@skinGetYourNewTreatment">
              Get started now with doctor given kit for your skin. It only takes 2
              minutes!
              </p>
            </div>
            <div class="tw-p-6 tw-text-200 tw-text-center" *ngIf="!regimen.expired && regimen.class === appConfig.Shared.Regimen.Class.HAIR">
              <p class="tw-text-300 tw-font-body tw-mb-4" i18n="@@hairGetYourNewTreatment">
              Get started now with doctor given kit for your hair. It only takes 2
              minutes!
              </p>
            </div>
          }
        </div>
      }
    </ng-container>
    <ng-container *ngIf="isRegimenExpired">
      <div class="tw-w-full tw-min-h-[calc(100vh-186px)] tw-flex tw-flex-col tw-items-center tw-justify-center tw-font-body tw-bg-gray-100">
        <div class="tw-w-max tw-h-max">
          <img class="tw-mx-auto tw-w-20 tw-h-20 tw-mb-4" [src]="iconSrc"/>
          @if (regimen.class === appConfig.Shared.Regimen.Class.HAIR) {
            <p class="tw-text-center tw-font-body tw-font-bold tw-text-500"> Get started with <br/> your hair treatment </p>
          } @else {
            <p class="tw-text-center tw-font-body tw-font-bold tw-text-500"> Get started with <br/> your skin treatment </p>
          }
          <p class="tw-text-center tw-font-body tw-font-normal tw-text-500"> to unlock doctor check-ups </p>
        </div>
      </div>
    </ng-container>
  </div>

  @if (isRouteMode && !newInstructionUIExperiment) {
    <div class="tw-w-full tw-p-4 tw-bg-white">
      <cs-button [class]="'w100 primary'"
                 [disabled]="isInternalUser"
                 (callback)="triggerTreeForRegimen()">
        @if (isRegimenExpiredForPaidUser) {
          <cs-button-text class="tw-font-body" i18n="@@restartTreatment">Restart Treatment</cs-button-text>
        } @else {
          <cs-button-text class="tw-font-body"
                          i18n="@@getYourTreatment">Get your treatment kit</cs-button-text>
        }
      </cs-button>
    </div>
  }
  @if (isRouteMode && newInstructionUIExperiment) {
    <div class="tw-w-full tw-p-4 tw-bg-white">
      <cs-button class="tw-bg-teal-600 tw-rounded-full"
                 [class]="'w100 primary'"
                 [disabled]="isInternalUser"
                 (callback)="triggerTreeForRegimen()">
        @if (isRegimenExpiredForPaidUser) {
          <cs-button-text class="tw-font-body" i18n="@@restartTreatment">Restart Treatment</cs-button-text>
        } @else {
          <cs-button-text class="tw-font-body"
                          i18n="@@getYourTreatment">Get your treatment kit</cs-button-text>
        }
      </cs-button>
    </div>
  }
</div>
